<template>
  <section class="reasons-container">
    <div class="title">
     <h2>
        <span>
          {{ props.nameCategory }}
          利用でタイムシェアリングが
        </span
        ><span style="color: #2b7eca">選ばれる理由</span>
     </h2>
     <p>The reason why Time Sharing is chosen</p>
    </div>
    <div class="reason-list">
      <div class="reason-item">
        <div class="num">01</div>
        <div class="image">
          <img :src="benefit" alt="benefit" style="width: 100%; height: 100%;"/>
        </div>
        <h3 class="title">
          <span>公式サイト特典！</span>
          <span>どこよりも安く使える</span>
        </h3>
        <div class="desc">
          <p>
            公式サイト【TIME SHARING】からの予約を最安値にしています。<br />
            一部、最安値の対象外となる場合がございますので予めご了承ください。
          </p>
          <p>・法人契約料金等の一般には公示されていない料金</p>
          <p>
            ・電話でしか予約を受け付けていない等、サイト上で予約が出来ない場合
          </p>
        </div>
      </div>
      <div class="reason-item">
        <div class="num">02</div>
        <div class="image">
          <img :src="unlimited" alt="unlimited" style="width: 100%; height: 100%;"/>
        </div>
        <h3 class="title">
          <span>設備､備品が無料で使い放題</span>
        </h3>
        <div class="desc">
          <p>
            マイク/プロジェクター/スクリーン/モニター/ホワイトボード/WiFiなど各レンタルスペースに常備している設備･備品は、使用料は無料でお使いいただけます。
          </p>
          <p>※設備･備品の詳細は各スペースページをご確認ください。</p>
          <p>※一部有料備品がございます。</p>
        </div>
      </div>
      <div class="reason-item">
        <div class="num">03</div>
        <div class="image">
          <img :src="usageTime" alt="usageTime" style="width: 100%; height: 100%;"/>
        </div>
        <h3 class="title">
          <span>希望に合わせて選べる利用時間</span>
        </h3>
        <div class="desc">
          <p>
            利用目的に合わせて｢3時間だけ｣､｢1日利用｣､｢1ヶ月丸々｣など自由にスペースをご予約いただけます。希望の日時に合うピッタリの会場がきっと見つかります。
          </p>
        </div>
      </div>
      <div class="reason-item">
        <div class="num">04</div>
        <div class="image">
          <img :src="deadline" alt="deadline" style="width: 100%; height: 100%;"/>
        </div>
        <h3 class="title">
          <span>当日予約も可能</span>
        </h3>
        <div class="desc">
          <p>急な利用にも対応して、直前まで予約を受け付けております。</p>
          <p>
            ※スペースごとに予約締切日が異なります。各スペースの「空室状況を確認する」をご確認ください。
          </p>
          <p>
            ※カレンダー上の空室表示がない場合でも、ご利用いただける可能性がございます。お電話でお問い合わせください。
          </p>
        </div>
      </div>
      <div class="reason-item">
        <div class="num">05</div>
        <div class="image">
          <img :src="easyEntry" alt="easyEntry" style="width: 100%; height: 100%;"/>
        </div>
        <h3 class="title">
          <span>誰でも簡単ラクラク入退室</span>
        </h3>
        <div class="desc">
          <p>
            入室は暗証番号を利用して入室となるため、無人対応となります。退室する時はメールで退室報告するだけで完了となります。
          </p>
          <p>
            ※一部違う場合もありますので、詳しくは予約後にお送りしております予約完了メールをご確認ください。
          </p>
        </div>
      </div>
      <div class="reason-item">
        <div class="num">06</div>
        <div class="image">
          <img :src="stations" alt="stations" style="width: 100%; height: 100%;"/>
        </div>
        <h3 class="title">
          <span>人気の駅近スペースを多数用意</span>
        </h3>
        <div class="desc">
          <p>
            人気の駅近くにある貸し会議室・レンタルスペースを中心に多くのスペースをご用意しています。エリアはもちろん、利用人数に応じて最適な会場を選ぶことができます。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import benefit from "@/client/assets/images/spaces/reasons/benefit.svg";
import deadline from "@/client/assets/images/spaces/reasons/deadline.svg";
import easyEntry from "@/client/assets/images/spaces/reasons/easy-entry.svg";
import stations from "@/client/assets/images/spaces/reasons/stations.svg";
import unlimited from "@/client/assets/images/spaces/reasons/unlimited.svg";
import usageTime from "@/client/assets/images/spaces/reasons/usage-time.svg";
import { defineProps } from "vue";

const props = defineProps({
  detailLocationName: {
    type: String,
  },
  nameCategory:{
    type: String
  }
});

</script>

<style scoped lang="scss">
@import "./ReasonList.scss";
</style>
